"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogOutMenuItem = exports.BlockListMenuItem = exports.SubscribeMenuItem = exports.QnAMenuItem = exports.SettingMenuItem = exports.UserGuideMenuItem = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
const svgs_1 = require("@@/assets/svgs");
const material_ui_confirm_1 = require("material-ui-confirm");
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const linkMenuItemSx = (isMemberMenu) => {
    return {
        height: '45px',
        padding: '8px 16px',
        fontSize: isMemberMenu ? '16px' : '14px',
    };
};
const UserGuideMenuItem = ({ isMemberMenu }) => ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ component: "a", href: "/fondee/service_center/", sx: linkMenuItemSx(isMemberMenu) }, { children: i18next_1.default.t('빠른 해결하기') })));
exports.UserGuideMenuItem = UserGuideMenuItem;
const SettingMenuItem = ({ isMemberMenu }) => ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ sx: linkMenuItemSx(isMemberMenu), onClick: () => (window.location.href = '/member/setting') }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SettingIconSvg, { css: { width: '24px', height: '24px', marginRight: '6px' } }), i18next_1.default.t('설정'), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { position: 'relative', display: 'flex', alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)("div", { css: {
                        position: 'absolute',
                        left: '3px',
                        width: '6px',
                        height: '6px',
                        backgroundColor: '#fff4ed',
                        transform: 'rotate(-45deg)',
                    } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                        marginLeft: 6,
                        padding: '4px 8px',
                        backgroundColor: '#fff4ed',
                        borderRadius: '100px',
                        fontWeight: 700,
                        fontSize: 13,
                        lineHeight: '16px',
                        color: 'var(--primary-dark)',
                    } }, { children: i18next_1.default.t('폼림픽 미리 준비하기') }))] }))] })));
exports.SettingMenuItem = SettingMenuItem;
const QnAMenuItem = ({ isMemberMenu }) => ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ component: "a", href: "/fondee/qna", sx: linkMenuItemSx(isMemberMenu) }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SmileBalloonIconSvg, { css: { marginRight: 6 } }), `${i18next_1.default.t('1:1 문의하기')}(${i18next_1.default.t('평일')} 11:00~18:00)`] })));
exports.QnAMenuItem = QnAMenuItem;
const SubscribeMenuItem = ({ isMemberMenu }) => ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ sx: linkMenuItemSx(isMemberMenu), onClick: () => (window.location.href = '/member/subscribe') }, { children: i18next_1.default.t('구독 관리') })));
exports.SubscribeMenuItem = SubscribeMenuItem;
const BlockListMenuItem = ({ isMemberMenu }) => ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ sx: linkMenuItemSx(isMemberMenu), onClick: () => (window.location.href = '/member/block-list') }, { children: i18next_1.default.t('차단 관리') })));
exports.BlockListMenuItem = BlockListMenuItem;
const LogOutMenuItem = ({ isMemberMenu }) => {
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const onLogOutClick = () => {
        confirm({ description: i18next_1.default.t('로그아웃 하시겠어요?') })
            .then(functions_1.logout)
            .catch(() => { });
    };
    return ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ sx: linkMenuItemSx(isMemberMenu), onClick: onLogOutClick }, { children: i18next_1.default.t('로그아웃') })));
};
exports.LogOutMenuItem = LogOutMenuItem;
